"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineBtnWithModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var LineButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/LineButton"));
var makeButtonWithModal = function (ButtonComp) {
    if (ButtonComp === void 0) { ButtonComp = Button_1.default; }
    return function (_a) {
        var renderOnlyOnOpen = _a.renderOnlyOnOpen, ModalComp = _a.modalComponent, openByDefault = _a.openByDefault, onClose = _a.onClose, onOpen = _a.onOpen, children = _a.children, modalProps = _a.modalProps, buttonProps = __rest(_a, ["renderOnlyOnOpen", "modalComponent", "openByDefault", "onClose", "onOpen", "children", "modalProps"]);
        var _b = __read(react_1.default.useState(openByDefault), 2), isModalOpen = _b[0], setIsModalOpen = _b[1];
        var closeFn = function () {
            if (onClose)
                onClose();
            setIsModalOpen(false);
        };
        var openFn = function () {
            if (onOpen)
                onOpen();
            setIsModalOpen(true);
        };
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(!renderOnlyOnOpen || isModalOpen) && ((0, jsx_runtime_1.jsx)(ModalComp, __assign({ label: "Nothing", open: isModalOpen, onClose: closeFn }, modalProps))), (0, jsx_runtime_1.jsx)(ButtonComp, __assign({ onClick: openFn }, buttonProps, { children: children }))] }));
    };
};
var ButtonWithModal = makeButtonWithModal();
exports.LineBtnWithModal = makeButtonWithModal(LineButton_1.default);
exports.default = ButtonWithModal;
